import TaskBoard from "../../views/TaskBoard";

const TaskBoardPage = () => {
  return <TaskBoard />;
};

export default TaskBoardPage;
